class ProcedureController {
  constructor() {
    this.name = 'procedure';
  }
}

export default ProcedureController;



// WEBPACK FOOTER //
// ./client/app/components/procedure/procedure.controller.js